module.exports = __webpack_public_path__ + "static/media/less_homeless.6976a9d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/less_homeless.png
// module id = 213
// module chunks = 0